import APP_ACTIONS from '../constants/app-actions';

const initialState = {

};

const anonymouseUser = (state = initialState, action) => {
    switch (action.type) {
    case APP_ACTIONS.ANONYMOUS_USER_AGE_VALID:
        return { ...state, ...action.payload };
    default:
        return state;
    }
};

export default anonymouseUser;



/** WEBPACK FOOTER **
 ** ./src/reducers/anonymous-user.js
 **/